import { Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { AccordionProps } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { AccordionRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRule';
import { ExpenseSettingsRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/ExpenseSettingsRule/ExpenseSettingsRuleHeader';
import { withRow } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/withRow';
import {
  ExpenseCodesSegmentedControl,
  ExpenseCodesSegmentedControlProps,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/ExpenseCodesSegmentedControl';
import {
  ExpenseCommentsSegmentedControl,
  ExpenseCommentsSegmentedControlProps,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/ExpenseCommentsSegmentedControl';
import {
  ExpenseReasonSegmentedControl,
  ExpenseReasonSegmentedControlProps,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/ExpenseReasonSegmentedControl';

export type ExpenseSettingsRuleProps = Omit<AccordionProps, 'header' | 'body'>;

const ExpenseCodesWithRow = withRow<ExpenseCodesSegmentedControlProps>(
  ExpenseCodesSegmentedControl
);
const ExpenseCommentsWithRow = withRow<ExpenseCommentsSegmentedControlProps>(
  ExpenseCommentsSegmentedControl
);
const ExpenseReasonWithRow = withRow<ExpenseReasonSegmentedControlProps>(
  ExpenseReasonSegmentedControl
);

export function ExpenseSettingsRule({
  ...props
}: ExpenseSettingsRuleProps): JSX.Element {
  const {
    corpDataValues: { expenseCodesForLabel },
  } = useMealCreditFormData();
  return (
    <AccordionRule
      {...props}
      header={(isActive): JSX.Element => (
        <ExpenseSettingsRuleHeader
          isActive={isActive}
          expenseCodesForLabel={expenseCodesForLabel}
        />
      )}
      body={(): JSX.Element => (
        <>
          <Stack y="sm">
            <ExpenseCodesWithRow
              id="expenseCodes"
              name="expenseCodes"
              label={`Require ${expenseCodesForLabel}?`}
            />
          </Stack>
          <Stack y="sm">
            <ExpenseCommentsWithRow
              id="expenseComments"
              name="expenseComments"
            />
          </Stack>
          <ExpenseReasonWithRow id="expenseReason" name="expenseReason" />
        </>
      )}
    />
  );
}
